import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const UpravenaList = lazy(() =>
  import('@/modules/vozidla/UpravenaList').then((m) => ({ default: m.UpravenaList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/upravena',
  component: () => (
    <Suspense fallback={null}>
      <UpravenaList />
    </Suspense>
  ),
});
